import { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    SelectChangeEvent,
} from "@mui/material";
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosError, AxiosResponse } from "axios";
import { errorAlert } from "../../utils/alerts/alerts";
import { useSelector } from "react-redux";
import { City, ReduxUserReducerState } from "../../types/global";

type Props = {
    filterValues: Record<string, string>;
    setFilterValues: Dispatch<SetStateAction<Record<string, string>>>;
};

const CityFilterBox = ({ filterValues, setFilterValues }: Props) => {
    const [loading, setLoading] = useState(true);
    const [cities, setCities] = useState<City[]>([]);
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const handleChange: any = (e: SelectChangeEvent<string>) => {
        setFilterValues({
            ...filterValues,
            cities: e.target.value,
        });
    };
    useEffect(() => {
        EnhancedAxios(null, userToken)
            .get(`/cities?&sorts=-name&page=1&paginate=120`)
            .then((res: AxiosResponse) => {
                const newCitiessForm = res.data.data.map((city: any) => {
                    const v = { id: city.id, name: city.name };
                    return v;
                });
                setCities(newCitiessForm);
                setLoading(false);
            })
            .catch((error: AxiosError) =>
                errorAlert(
                    "حدث خطا اثناء العرص التصنيفات برجاء اعادة تحميل الصفحة"
                )
            );
    }, []);
    return (
        <Box
            sx={{
                flex: "1",
                minWidth: "200px",
            }}
        >
            <FormControl fullWidth>
                <InputLabel>المدينة</InputLabel>
                <Select
                    name="cities_filter"
                    value={filterValues.cities}
                    label="المدينة"
                    onChange={handleChange}
                >
                    {cities?.map((option) => {
                        return (
                            <MenuItem value={option.id} key={option.id}>
                                {option.name}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </Box>
    );
};

export default CityFilterBox;
